<div class="define-content">
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
